import React from "react";
import ArrowBack from "@images/profile/arrow_back.svg";
import RightArrow from "@images/profile/arrow_right.svg";
import ProfileHistory from "./ProfileHistory";
import { GavelIcon } from "@util/svgicon";

const ProfileAppeal = ({ onclick,SubmitAppeal }) => {
  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <button
          onClick={onclick}
          className="bg-black px-[12px] text-[16px] leading-[22px] py-[10px] text-white flex gap-[4px] rounded-full"
        >
          <img src={ArrowBack} /> Cancel appeal
        </button>
        <div className="flex gap-[16px] mr-[100px]">
          <p className=" text-black font-medium	text-[16px] leading-[22px]">{SubmitAppeal ? 'Life Points' : 'Profile'}</p>
          <div>
            <img src={RightArrow} />
          </div>
          <p className="text-black font-medium text-[16px] leading-[22px]"> {SubmitAppeal ? 'Nov 11, Mission 182' : '1st Warning'} </p>
          <div>
            <img src={RightArrow} />
          </div>
          <p className="text-black font-medium text-[16px] leading-[22px]">Appeal</p>
        </div>
        <div />
      </div>
      <div className="max-w-[512px] mx-auto lg:mt-[56px] md:mt-[32px]  mt-[30px] flex flex-col gap-[20px]">
        <h4 className="text-black lg:text-[42px] lg:leading-[42px] md:text-[18px] md:leading-[36px]	 text-[30px] leading-[32px] font-semibold text-center">
        {SubmitAppeal ? 'Submit an appeal' : 'Settings'} 
        </h4>
        <div className="bg-white rounded-2xl p-[24px]">
          <div className="grid grid-cols-11 gap-[20px]">
            <div className="py-[10px]">
              {" "}
              <GavelIcon className="fill-black w-[24px] h-[24px]" />
            </div>
            <div className="col-span-10 flex flex-col gap-[4px]">
              <p className="text-black text-[20px] leading-[28px] font-semibold">You can file an appeal here.</p>
              <div className="text-gray text-[16px] font-medium leading-[22px]">
                You can describe what happened, a recording of the previous 30
                seconds prior to termination will be provided.
              </div>
            </div>
          </div>
        </div>
        <ProfileHistory btnLabel="Submit appeal">
          <div>
            <p className="text-[13px] text-black font-medium mb-1">
              Description (Max. 500 words)
            </p>
            <div className="border border-gray border-solid rounded-lg">
              <textarea
                placeholder="Type here..."
                className="p-4 w-full rounded-lg focus:focus-visible:outline-none text-black"
                rows={6}
              />
            </div>
          </div>
        </ProfileHistory>
      </div>
    </div>
  );
};

export default ProfileAppeal;
